import { atom } from "jotai";

import { UserInfo } from "@/services/User/userTypes";

export const userInfoAtom = atom<UserInfo | undefined>(undefined);

export const vipModalShowAtom = atom<boolean>(false);